import * as React from 'react'
import { useHistory, useParams } from 'react-router'
import { ContentURLParams } from '../types'
import { Routes } from '../../../../constants';
import { useSearchParams } from '../../../../utils/hooks';

type NavigateContentPage = (
    params: { channel?: number; playlist?: number; search?: string },
) => void

interface UseContentURLParamsOutput {
    navigateInContentPage: NavigateContentPage;
    selectedEstate: string;
    selectedChannelId: number;
    selectedPlaylistId: number;
    searchChannel: string;
}

export default function useContentURLParams(): UseContentURLParamsOutput {
    const history = useHistory()
    const {
        channel: selectedChannelIdStr,
        estate: selectedEstate,
        playlist: selectedPlaylistIdStr,
    } = useParams<ContentURLParams>()
    const selectedChannelId = selectedChannelIdStr ? parseInt(selectedChannelIdStr) : undefined
    const selectedPlaylistId = selectedPlaylistIdStr ? parseInt(selectedPlaylistIdStr) : undefined
    const [searchParams] = useSearchParams()

    return React.useMemo(() => {
        const searchChannel = searchParams.get('s') ?? ''

        const navigateInContentPage: NavigateContentPage = (
            { channel, playlist, search },
        ) => {
            const route = [Routes.CONTENT]
            const newSearchParams = new URLSearchParams(searchParams)

            if (search || searchChannel) {
                newSearchParams.set('s', search ?? searchChannel)
            }

            if (newSearchParams.size > 0) {
                route.push(newSearchParams.toString())
            }
    
            const params = { estate: selectedEstate } as ContentURLParams
    
            if (channel) {
                params.channel = String(channel)
            }
    
            if (playlist) {
                params.playlist = String(playlist)
            }
    
            history.replace(Routes.buildRoute(route.join('?'), params))
        }

        return {
            navigateInContentPage,
            selectedEstate,
            selectedChannelId,
            selectedPlaylistId,
            searchChannel,
        } as UseContentURLParamsOutput
    }, [
        history,
        searchParams,
        selectedChannelId,
        selectedEstate,
        selectedPlaylistId,
    ])
}
